import { render, staticRenderFns } from "./AlertaManutencaoLista.vue?vue&type=template&id=1960405e&lang=html"
import script from "./AlertaManutencaoLista.vue?vue&type=script&lang=js"
export * from "./AlertaManutencaoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports